"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_1 = require("./styled");
function ImageUpload(_a) {
    var image = _a.image, text = _a.text, onChange = _a.onChange;
    var input = react_1.createRef();
    var onSelectFile = function () {
        if (!!input.current) {
            input.current.click();
        }
    };
    return (react_1.default.createElement(styled_1.StyledImageUpload, { className: "gray2-text gray0-bg", onClick: onSelectFile },
        image ? react_1.default.createElement(styled_1.StyledImage, { src: image, alt: "" }) : text,
        react_1.default.createElement(styled_1.StyledImageInput, { type: "file", accept: "image/*", ref: input, onChange: onChange })));
}
ImageUpload.defaultProps = {
    text: 'Upload Photo',
};
exports.default = ImageUpload;
//# sourceMappingURL=index.js.map